import { SignatureBlockProps } from "./type";

interface Props {
  blockProps: SignatureBlockProps;
  scaleFactor?: number;
}

export const SignatureBlock: React.FC<Props> = ({ blockProps, scaleFactor = 1 }) => {
  const { maxHeight, maxWidth, label, imageUrl, mappingKey } = blockProps;
  const { caption, name, qualification, specialization, nmc, nhpc_no } = blockProps;

  const scaledHeight = maxHeight * scaleFactor;
  const scaledWidth = maxWidth * scaleFactor;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      {imageUrl ? (
        <div
          style={{
            height: scaledHeight,
            width: scaledWidth,
            overflow: "hidden",
          }}
        >
          <img
            src={imageUrl}
            alt={`signature-${mappingKey}`}
            style={{
              height: "100%",
              width: "100%",
              objectFit: "contain",
            }}
          />
        </div>
      ) : (
        <div
          style={{
            height: scaledHeight,
            width: scaledWidth,
            fontSize: `${10 * scaleFactor}px`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            flexDirection: "column",
            whiteSpace: "normal",
            wordWrap: "break-word",
          }}
        >
          {label}
        </div>
      )}

      <div
        style={{
          height: 5 * scaleFactor,
          width: 100 * scaleFactor,
          borderBottom: "1px dashed #000",
        }}
      />
      {caption && <div style={{ fontSize: `${10 * scaleFactor}px` }}>{caption}</div>}
      {name && <div style={{ fontSize: `${10 * scaleFactor}px` }}>{name}</div>}
      {qualification && <div style={{ fontSize: `${10 * scaleFactor}px` }}>{qualification}</div>}
      {specialization && <div style={{ fontSize: `${10 * scaleFactor}px` }}>{specialization}</div>}
      {nmc && <div style={{ fontSize: `${10 * scaleFactor}px` }}>NMC No. {nmc}</div>}
      {nhpc_no && <div style={{ fontSize: `${10 * scaleFactor}px` }}>NHPC No. {nhpc_no}</div>}
    </div>
  );
};
